import React from "react";
import { Check } from "lucide-react";

interface StepperProps {
  currentStep: number;
  steps: string[];
}

const Stepper: React.FC<StepperProps> = ({ currentStep, steps }) => {
  return (
    <ul className="relative flex w-full justify-between items-center mb-6">
      {steps.map((label, index) => {
        const step = index + 1;
        return (
          <li
            key={step}
            className={`flex items-center gap-x-2 ${index < steps.length - 1 ? "flex-1" : ""} group ${currentStep >= step ? "hs-stepper-completed" : ""}`}
          >
            <div className="flex items-center">
              <span
                className={`size-8 flex justify-center items-center rounded-full whitespace-nowrap ${
                  currentStep >= step ? "bg-primary text-white" : "bg-gray-100 text-gray-800"
                }`}
              >
                {currentStep > step ? <Check className="h-5 w-5" /> : step}
              </span>
              <span className="ml-2 text-sm font-medium text-gray-800 dark:text-neutral-200 whitespace-nowrap">
                {label}
              </span>
            </div>
            {index < steps.length - 1 && <div className="flex-grow h-px bg-gray-300 mx-3"></div>}
          </li>
        );
      })}
    </ul>
  );
};

export default Stepper;
